import React from 'react';
import PropTypes from 'prop-types';

const IconDot = ({ width = '6', height = '6', viewBox = '0 0 6 6', color = '#0051FF' }) =>
	<svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
		<circle cx='3' cy='3' r='3' fill={color} />
	</svg>;

IconDot.propTypes = {
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	viewBox: PropTypes.string,
	color: PropTypes.string
};

export default React.memo(IconDot);
